module.exports = __webpack_public_path__ + "img/clap.18d1fc33.png";